/**
 * Endless's active survival TIME formatting: `MM:SS` for runs under one
 * hour, `H:MM:SS` for longer ones. `ms` must already be active
 * (pause-excluded) time - this function has no notion of "now" or
 * pause/background state itself, same as every other real-time value in
 * this engine (see `LevelGame`'s own `activeElapsedMs`).
 */
export function formatSurvivalTime(ms: number): string {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const mm = String(minutes).padStart(2, "0");
  const ss = String(seconds).padStart(2, "0");
  return hours > 0 ? `${hours}:${mm}:${ss}` : `${mm}:${ss}`;
}
